import {CLIENTS} from './clientsActionTypes';
export function getCompaniesClientsList(id) {
  return {
    type: CLIENTS.GET_COMPANY_CLIENTS_LIST,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/clients`,
        method: 'get'
      }
    }
  };
}

export function getCompaniesClients(id) {
  return {
    type: CLIENTS.GET_COMPANY_CLIENTS,
    payload: {
      client: 'default',
      request: {
        url: `clients/${id}`,
        method: 'get'
      }
    }
  };
}

export function getCompaniesClientsPopup(id) {
  return {
    type: CLIENTS.GET_COMPANY_CLIENTS_POPUP,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/clients?filter[status]=active`,
        method: 'get'
      }
    }
  };
}

export function postCompaniesClients(companyId, clientId, data) {
  return {
    type: CLIENTS.POST_COMPANIES_CLIENTS,
    payload: {
      client: 'default',
      request: {
        url: `companies/${companyId}/clients/${clientId}`,
        method: 'post',
        data
      }
    }
  };
}

export function postClients(data) {
  return {
    type: CLIENTS.POST_CLIENTS,
    payload: {
      client: 'default',
      request: {
        url: `clients`,
        method: 'post',
        data
      }
    }
  };
}

export function patchCompanyClientBlock(companyId, clientId) {
  return {
    type: CLIENTS.PATCH_COMPANY_CLIENT_BLOCK,
    payload: {
      client: 'default',
      request: {
        url: `companies/${companyId}/clients/${clientId}/block`,
        method: 'patch'
      }
    }
  };
}

export function patchCompanyClientReturn(companyId, clientId) {
  return {
    type: CLIENTS.PATCH_COMPANY_CLIENT_RETURN,
    payload: {
      client: 'default',
      request: {
        url: `companies/${companyId}/clients/${clientId}/return`,
        method: 'patch'
      }
    }
  };
}

export function clearClients() {
  return {
    type: CLIENTS.CLEAR_CLIENTS,
    payload: {}
  };
}
